export default __webpack_public_path__ + "static/media/image-not-found.c4ba1e76.png";